import { render, staticRenderFns } from "./BuildYourShop.vue?vue&type=template&id=daca61e6"
import script from "./BuildYourShop.vue?vue&type=script&lang=js"
export * from "./BuildYourShop.vue?vue&type=script&lang=js"
import style0 from "./BuildYourShop.vue?vue&type=style&index=0&id=daca61e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daca61e6')) {
      api.createRecord('daca61e6', component.options)
    } else {
      api.reload('daca61e6', component.options)
    }
    module.hot.accept("./BuildYourShop.vue?vue&type=template&id=daca61e6", function () {
      api.rerender('daca61e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BuildYourShop.vue"
export default component.exports